module.exports = __webpack_public_path__ + "img/points-wallets.e012da61.svg";